import { Checkbox, InfoBlock, RadioButtons, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect } from "react";
import { WizarContext, singleCommunicationInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

// import { singleOtherAddressesInfoActionCreator } from "contexts/WizardContext";

const CommunicationInfo = ({ errors, setErrors }) => {
  let magazines = [
    { value: "TEC21", label: "TEC21" },
    { value: "TRACES", label: "TRACES" },
    { value: "ARCHI", label: "ARCHI" },
    { value: "ARCHI + TEC21", label: "ARCHI + TEC21" },
    { value: "ARCHI + TRACES", label: "ARCHI + TRACES" },
    { value: "", label: "Keine" },
  ];
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  let communicationInfo = state.single.communicationInfo;
  // let communicationInfoErrors = errors.single.communicationInfo;
  let changState = useCallback((payload) => dispatch(singleCommunicationInfoActionCreator(payload)), [dispatch]);
  // const resetInputFieldError = (property) => {
  //   if (errors.single.communicationInfo[property]) {
  //     setErrors((errorsState) => ({
  //       ...errorsState,
  //       single: {
  //         ...errorsState.single,
  //         communicationInfo: { ...errorsState.single.communicationInfo, [property]: "" },
  //       },
  //     }));
  //   }
  // };

  const { user } = useContext(GlobalContext);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    webPlatformAdapter.getWizardSession(userId, (data) => {
      const updatedSession = { ...data, communicationInfo: { ...data.communicationInfo, ...obj } };
      webPlatformAdapter.setWizardSession(userId, { ...updatedSession });
    });
  };

  useEffect(() => {
    if (userId) {
      webPlatformAdapter.getWizardSession(userId, (data) => {
        const defaultCommunicationInfo = { ...initialWizardFormState.single.communicationInfo };
        const { communicationInfo } = data;
        const { selectedMagazine, magazineFormatEpaper, magazineFormatPrinted, newsLetterGerman, newsLetterFrench } =
          communicationInfo || defaultCommunicationInfo;
        changState({
          selectedMagazine: selectedMagazine || "",
          magazineFormatEpaper: magazineFormatEpaper || false,
          magazineFormatPrinted: magazineFormatPrinted || false,
          newsLetterGerman: newsLetterGerman || false,
          newsLetterFrench: newsLetterFrench || false,
        });
      });
    }
  }, [userId, changState]);

  return (
    <div className="communication-info-page">
      <p className="">{translate("wizard.form.single.communication.info")}</p>
      <div className="sia-margin-03-top">
        <InfoBlock loose>
          <span className="label">{translate("wizard.form.single.communication.magazins.label")}</span>
          <div className="sia-margin-01-top communication-magazine">
            <RadioButtons
              name={"communication-page-radio"}
              items={magazines}
              selectedValue={communicationInfo.selectedMagazine}
              onChange={(value) => {
                changState({ selectedMagazine: value });
                setUserSession({ selectedMagazine: value });
              }}
            />
            <div>
              <Checkbox
                id={"communication-page-ePaper"}
                label={translate("E-paper")}
                value={communicationInfo.magazineFormatEpaper}
                onChange={(event, value) => {
                  changState({ magazineFormatEpaper: value });
                  setUserSession({ magazineFormatEpaper: value });
                }}
              />
              <Checkbox
                id={"communication-page-printed"}
                label={"gedruckt"}
                value={communicationInfo.magazineFormatPrinted}
                onChange={(event, value) => {
                  changState({ magazineFormatPrinted: value });
                  setUserSession({ magazineFormatPrinted: value });
                }}
              />
            </div>
          </div>
          <span className="label sia-margin-03-top">{translate("wizard.form.single.communication.newsletter.label")}</span>
          <Checkbox
            id={"communication-page-nsd"}
            label={translate("wizard.form.single.communication.newsletter.german.label")}
            value={communicationInfo.newsLetterGerman}
            onChange={(event, value) => {
              changState({ newsLetterGerman: value });
              setUserSession({ newsLetterGerman: value });
            }}
          />
          <Checkbox
            id={"communication-page-nsf"}
            label={translate("wizard.form.single.communication.newsletter.french.label")}
            value={communicationInfo.newsLetterFrench}
            onChange={(event, value) => {
              changState({ newsLetterFrench: value });
              setUserSession({ newsLetterFrench: value });
            }}
          />
        </InfoBlock>
      </div>
    </div>
  );
};

export default CommunicationInfo;
